import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const integrationOverviewTabContent = EntityContentBlueprint.make({
  name: 'integration-overview',
  params: {
    path: '/',
    title: 'Overview',
    group: 'overview',
    filter: { kind: 'Integration' },
    loader: () =>
      import('./components').then(m => <m.IntegrationOverviewTabContent />),
  },
});

const projectIntegrationsTabContent = EntityContentBlueprint.make({
  name: 'project-integrations',
  params: {
    path: '/integrations',
    title: 'Integrations',
    group: 'integrations',
    filter: { kind: 'Domain' },
    loader: () =>
      import('./components').then(m => <m.ProjectIntegrationsTabContent />),
  },
});

export default [integrationOverviewTabContent, projectIntegrationsTabContent];
